"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const useActionToken_1 = __importDefault(require("~/hooks/useActionToken"));
const selectors_1 = require("~/store/selectors");
const react_redux_1 = require("react-redux");
const Authorization_1 = __importDefault(require("~/components/Authorization"));
const ErrorModals_1 = require("../ErrorModals");
function DistributorRoute() {
    const isDirectAccount = (0, react_redux_1.useSelector)(selectors_1.selectIsDirectAccount);
    const [, isTokenValid, decoded] = (0, useActionToken_1.default)(localStorage.token);
    const [state, setState] = (0, react_1.useState)('undefined');
    (0, react_1.useEffect)(() => {
        if (isTokenValid !== null && decoded !== undefined) {
            const isDistributor = isTokenValid && decoded && decoded.distributorId !== null;
            if (!isDistributor) {
                setState('unauthorized');
            }
            else if (isDirectAccount !== undefined) {
                setState(isDirectAccount ? 'unauthorized' : 'authorized');
            }
        }
        else if (isTokenValid === false) {
            setState('not-signed-in');
        }
    }, [isDirectAccount, decoded, isTokenValid]);
    switch (state) {
        case 'unauthorized':
            return react_1.default.createElement(ErrorModals_1.ForbiddenModal, null);
        case 'authorized':
            return react_1.default.createElement(react_router_dom_1.Outlet, null);
        case 'not-signed-in':
            return react_1.default.createElement(Authorization_1.default, null);
        default:
            return null;
    }
}
exports.default = DistributorRoute;
